import styled from 'styled-components';
import { Button } from '@mui/material';

/* ─── Brand tokens (shared with ServiceRequests) ─── */
const brand = {
  blue: '#0d4efe',
  teal: '#01ebb2',
  textPrimary: '#1a2340',
  textSecondary: '#5a6478',
  textMuted: '#8a93a6',
  border: '#e0e5f0',
  inputBg: '#f7f9fc',
  white: '#ffffff',
  warning: '#b7791f',
  warningBg: 'rgba(217, 119, 6, 0.08)',
  warningBorder: 'rgba(217, 119, 6, 0.35)',
};

/* ─── Default-behavior notice (email-on-file callout) ─── */
export const DefaultNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  font-family: 'Roboto', sans-serif;
  font-size: 0.88rem;
  line-height: 1.6;
  color: ${brand.textPrimary};
  margin: 0 0 1.75rem;
  padding: 0.85rem 1.1rem;
  background: ${brand.inputBg};
  border-left: 3px solid ${brand.teal};
  border-radius: 0 10px 10px 0;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
    font-size: 1.1rem;
    color: ${brand.blue};
  }
`;

/* ─── Enable / disable toggle row ─── */
export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.25rem;
  background: ${brand.white};
  border: 1px solid ${brand.border};
  border-radius: 12px;
  margin-bottom: 0.5rem;
`;

export const ToggleTitle = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  color: ${brand.textPrimary};
`;

export const ToggleSubtitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 0.8rem;
  color: ${brand.textMuted};
  margin-top: 2px;
`;

/* ─── Phone-source radio cards ─── */
export const PhoneOptionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.85rem 1.1rem;
  margin-bottom: 0.75rem;
  border: 1.5px solid ${(props) => (props.$selected ? brand.blue : brand.border)};
  background: ${(props) => (props.$selected ? 'rgba(13, 78, 254, 0.05)' : brand.white)};
  border-radius: 12px;
  transition: border-color 0.15s ease, background 0.15s ease;

  .MuiFormControlLabel-root {
    margin: 0;
    align-items: flex-start;
  }
  .MuiFormControlLabel-label {
    margin-top: 2px;
  }
`;

export const PhoneOptionDetail = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 0.82rem;
  color: ${brand.textMuted};
  margin-top: 1px;
`;

export const FieldHint = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 0.8rem;
  color: ${brand.warning};
  background: ${brand.warningBg};
  border: 1px solid ${brand.warningBorder};
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  margin: -0.25rem 0 1rem;

  a {
    color: ${brand.blue};
    font-weight: 600;
  }
`;

/* ─── Consent card (10DLC / Telnyx web-form opt-in pattern) ─── */
export const ConsentCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: ${brand.white};
  border: 1px solid ${brand.border};
  border-radius: 14px;
  padding: 1.25rem 1.4rem;
  margin-bottom: 1.5rem;
`;

export const ConsentDescription = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 0.88rem;
  line-height: 1.6;
  color: ${brand.textPrimary};
  margin: 0;
`;

export const ConsentMeta = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 0.82rem;
  line-height: 1.55;
  color: ${brand.textSecondary};
  margin: 0;

  a {
    color: ${brand.blue};
    font-weight: 600;
  }
`;

export const ConsentCheckboxRow = styled.div`
  margin-top: 0.25rem;
  padding-top: 0.75rem;
  border-top: 1px solid ${brand.border};

  .MuiFormControlLabel-label {
    font-family: 'Roboto', sans-serif;
    font-size: 0.88rem;
    font-weight: 600;
    color: ${brand.textPrimary};
  }
`;

/* ─── Save / cancel actions ─── */
export const SaveButton = styled(Button)`
  margin-top: 0.5rem;
  margin-right: 12px;
  background: linear-gradient(135deg, ${brand.teal}, #0bbfa0) !important;
  color: #fff !important;
  font-weight: 700;
  text-transform: none;
  border-radius: 10px;
  padding: 10px 28px;
  font-size: 0.95rem;
  box-shadow: 0 2px 8px rgba(1, 235, 178, 0.3) !important;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(1, 235, 178, 0.45) !important;
    transform: translateY(-1px);
  }

  &.Mui-disabled {
    background: ${brand.border} !important;
    color: ${brand.textMuted} !important;
    box-shadow: none !important;
  }
`;

export const SaveHint = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 0.8rem;
  color: ${brand.textMuted};
  margin: 0.5rem 0 0;
`;
